import React from 'react';
import styled from 'styled-components';
import { Button as SuiButton, ButtonProps as SuiButtonProps } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { lighten, modularScale } from 'polished';

const Button = ({ as, basic, borderless = false, primary = false, secondary = false, lookLikeAnchor = false, ...rest }:ButtonProps) => {
	const backgroundColor = useSelector(state => { return primary ? state.ui.customer.primaryColor : secondary ? state.ui.customer.secondaryColor : null; });

	// If there isn't any extra styling, just return the vanilla semantic UI button
	if (!primary && !secondary && !borderless && !lookLikeAnchor) {
		return <SuiButton as={as} { ...rest } />;
	}
	else {
		return <StyledButton
			backgroundColor={!lookLikeAnchor && backgroundColor}
			asRenamed={as}
			borderless={borderless || lookLikeAnchor}
			basic={basic || lookLikeAnchor}
			lookLikeAnchor={lookLikeAnchor}
			{ ...rest }
		/>;
	}
};

// Create a wrapper component for the semantic UI button with the "as" attribute
// renamed so that it doesn't conflict with styled-components' "as" attribute
const MiddleManButton = ( {asRenamed, backgroundColor, borderless, lookLikeAnchor, ...rest }:MiddleManButtonProps) => <SuiButton as={asRenamed} { ...rest } />;

// Create the styled component and apply the styling
const StyledButton = styled(MiddleManButton)`
	${(p: MiddleManButtonProps) => `
		${p.borderless ? 'border: none !important; box-shadow: none !important;' : ''}

		${p.backgroundColor !== undefined && p.backgroundColor !== null &&
			`&&& {
				color: #ffffff !important;
			}

			&&&:not(:hover):not(:focus):not(:active) {
				background-color: ${p.backgroundColor || 'unset'};
			}

			&&&:hover:not(:active),
			&&&:focus:not(:active) {
				background-color: ${lighten(.1, p.backgroundColor || '#ffffff')};
			}

			&&&:active {
				background-color: ${lighten(.2, p.backgroundColor || '#ffffff')};
			}`}

		${p.lookLikeAnchor &&
			`&&&,
			&&&:hover,
			&&&:active,
			&&&:focus {
				background: unset !important;
				color: #0000EE !important;
				cursor: pointer;
			}

			&&&:hover {
				text-decoration: underline;	
			}`}
	`}
`;

export interface ButtonProps extends SuiButtonProps {
	borderless?:boolean,
	lookLikeAnchor?:boolean
}

interface MiddleManButtonProps extends SuiButtonProps {
	borderless?:boolean,
	backgroundColor?:string,
	lookLikeAnchor?:boolean
}

export default Button;